export const RX = {
    COMPLETE_REGISTRATION: {
        CLEAR_BRANCH: 'RX_COMPLETE_REGISTRATION:CLEAR_BRANCH',
        SIGN_IN_WITH_MANHEIM_ACCOUNT: 'RX_COMPLETE_REGISTRATION:SIGN_IN_WITH_MANHEIM_ACCOUNT',
        VERIFY_WITH_AUCTION_ACCESS: 'RX_COMPLETE_REGISTRATION:VERIFY_WITH_AUCTION_ACCESS',
        CREATE_NEW_ACCOUNT: 'RX_COMPLETE_REGISTRATION:CREATE_NEW_ACCOUNT',
        GET_ORG_USER_BY_TOKEN: 'RX_COMPLETE_REGISTRATION:GET_ORG_USER_BY_TOKEN'
    },
    VERIFY_AUCTION_ACCESS: {
        CLEAR_BRANCH: 'RX_VERIFY_AUCTION_ACCESS:CLEAR_BRANCH',
        SUBMIT_FORM: 'RX_VERIFY_AUCTION_ACCESS:SUBMIT_FORM'
    },
    CREATE_NEW_ACCOUNT: {
        CLEAR_BRANCH: 'RX_CREATE_NEW_ACCOUNT:CLEAR_BRANCH',
        GET_ORG_USER_BY_TOKEN: 'RX_CREATE_NEW_ACCOUNT:GET_ORG_USER_BY_TOKEN',
        CANCEL: 'RX_CREATE_NEW_ACCOUNT:CANCEL',
        SUBMIT: 'RX_CREATE_NEW_ACCOUNT:SUBMIT',
        REMOVE_PHONE_VALIDATION_ERROR: 'RX_CREATE_NEW_ACCOUNT:REMOVE_PHONE_VALIDATION_ERROR',
        REMOVE_USERNAME_VALIDATION_ERROR: 'RX_CREATE_NEW_ACCOUNT:REMOVE_USERNAME_VALIDATION_ERROR'
    },
    LANDING: {
        GET_IMAGE_URL: 'RX_LANDING:GET_IMAGE_URL',
        CHANGE_IS_LANDING_MODAL_OPENED: 'RX_LANDING:CHANGE_IS_LANDING_MODAL_OPENED',
        GET_PUBLIC_CONTENT_TEMPLATES: 'RX_LANDING:GET_PUBLIC_CONTENT_TEMPLATES'
    }
};
